export const ERROR_CODE = {
  SUCCESS: 0, // 成功
  UNKNOWN: 9999, // 未知错误
  INVALID_PARAMS: 1000, // 参数无效
  DATABASE_ERROR: 1001, // 数据库错误
  NOT_LOGIN: 1002, // 用户未登录
  SEND_CODE_FAIL: 1003, // 短信验证码发送失败
  NO_PERMISSION: 1004, // 权限不足
  NOT_FOUND: 1005, // 找不到指定资源
  CODE_ERROR: 1006, // 验证码错误
  SAVE_FAIL: 1007, // 素材预览数据保存失败
  INSUFFICIENT_GOLD: 1008, // 积分不足
  EMAIL_ADDR_UNSET: 1009, // 用户未设置邮箱
  SEND_EMAIL_FAIL: 1010, // 邮件发送失败
  CODE_TIMES_EXCEEDED: 1011, // 当日发送验证码次数已超限
  HASH_CODE_FAIL: 1012, // Hash校验失败
  PHONE_REGISTERED: 1013 // 该手机号码已报名
}

export const API_ORIGIN = process.env.VUE_APP_API_ORIGIN || ''
export const API_ROOT = process.env.VUE_APP_API_ROOT || ''
export const API_PREFIX = API_ORIGIN + API_ROOT || '/api'
